const liveHosts = new Set([
  'setup-coding.de',
  'www.setup-coding.de',
  'overwatchpixelmixer.setup-coding.de',
  'overwatchcutemixer.setup-coding.de',
]);

export function getMixerContext(location) {
  if (!location || !liveHosts.has(location.hostname)) return null;
  const path = location.pathname.replace(/\/index\.html$/, '').replace(/\/$/, '');
  let mixer;
  if (path === '/overwatchpixelmixer') mixer = 'pixel';
  else if (path === '/overwatchcutemixer') mixer = 'cute';
  else if (!path && location.hostname === 'overwatchpixelmixer.setup-coding.de') mixer = 'pixel';
  else if (!path && location.hostname === 'overwatchcutemixer.setup-coding.de') mixer = 'cute';
  if (!mixer) return null;
  return {
    site_area: 'overwatch',
    mixer,
    mixer_name: mixer === 'pixel' ? 'Overwatch PixelMixer' : 'Overwatch CuteMixer',
    mixer_path: `/overwatch${mixer}mixer`,
  };
}

export function trackMixerEvent(event, properties = {}, target = typeof window === 'undefined' ? null : window) {
  const context = getMixerContext(target && target.location);
  if (!context || !target.posthog || typeof target.posthog.capture !== 'function') return false;
  if (['1', 'yes'].includes(String(target.navigator && target.navigator.doNotTrack))
    || ['1', 'yes'].includes(String(target.doNotTrack))) return false;
  try {
    target.posthog.capture(event, {
      ...properties,
      ...context,
      // Mix parameters describe an image, not another page. Keep page URLs stable.
      $current_url: target.location.origin + target.location.pathname,
      $pathname: target.location.pathname,
    });
    return true;
  } catch {
    // Optional analytics must never interrupt the mixer controls.
    return false;
  }
}

export function createMixerPageTracker(capture = trackMixerEvent) {
  let previous = null;
  return (location) => {
    const page = getMixerContext(location);
    if (!page) { previous = null; return false; }
    const key = `${location.hostname}:${page.mixer}`;
    if (key === previous) return false;
    if (!capture('$pageview')) return false;
    previous = key;
    return true;
  };
}
